import { Model } from '../parents/model';

export class CurrencyModel extends Model {
  static ATTR_ID = 'id';

  static ATTR_NAME = 'name';

  static ATTR_DECIMAL_PLACES = 'decimal_places';

  static ATTR_NUMERIC_CODE = 'numeric_code';

  static ATTR_SYMBOL = 'symbol';

  static ATTR_IS_ACTIVE = 'is_active';

  static ATTR_IS_DEFAULT = 'is_default';

  static ATTR_ROUNDING_SCALE = 'rounding_scale';

  static ATTR_ROUNDING_METHOD = 'rounding_method';

  get name() {
    return this.attributes[CurrencyModel.ATTR_NAME];
  }

  get decimalPlaces() {
    return this.attributes[CurrencyModel.ATTR_DECIMAL_PLACES];
  }

  get numericCode() {
    return this.attributes[CurrencyModel.ATTR_NUMERIC_CODE];
  }

  get symbol() {
    return this.attributes[CurrencyModel.ATTR_SYMBOL];
  }

  get isActive() {
    return this.attributes[CurrencyModel.ATTR_IS_ACTIVE];
  }

  get isDefault() {
    return this.attributes[CurrencyModel.ATTR_IS_DEFAULT];
  }

  get roudingScale() {
    return this.attributes[CurrencyModel.ATTR_ROUNDING_SCALE];
  }

  get roundingMethod() {
    return this.attributes[CurrencyModel.ATTR_ROUNDING_METHOD];
  }
}
